export const HAS_SIGNED_IN_KEY = 'ls:auth:hasSignedIn';
